import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router-dom'
import ReactGA from 'react-ga'
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent'
import { loadStories } from './store/storiesReducer'
import { StylesProvider } from '@material-ui/core/styles'
import GameDay from './GameDay'
import Story from './Story'
import FullPageCover from './FullPageCover'
import { loadExhibit, selectExhibit } from './store/exhibitReducer'

function App() {
  const dispatch = useDispatch()
  const exhibitId = window.exhibitId

  const gaTrackingCode = window.gaTrackingCode
  const location = useLocation()

  const handleAcceptCookie = () => ReactGA.initialize(gaTrackingCode)
  const exhibit = useSelector(selectExhibit)

  useEffect(() => {
    dispatch(loadStories(exhibitId))
    dispatch(loadExhibit(exhibitId))
  }, [dispatch, exhibitId])

  useEffect(() => {
    if(exhibit.image) document.getElementById('favicon').href = exhibit.image
  }, [exhibit])


  useEffect(() => {
    const isConsent = getCookieConsentValue()
    if (isConsent === 'true') {
      handleAcceptCookie()
    }
  }, [])

  useEffect(() => {
    ReactGA.pageview(location.pathname)
  }, [location])

  return (
    <StylesProvider injectFirst>
      <Switch>
        <Route path='/gameday/:name/program/story/:id' render={(props) => <Story {...props} />} />
        <Route path='/gameday/:name/program' render={(props) => <GameDay {...props} />} />
        <Route path='/gameday/:name' render={(_) => <FullPageCover />} />
      </Switch>
      { gaTrackingCode != '__EXHIBIT_GA_TOKEN__' && <CookieConsent onAccept={handleAcceptCookie}>This website uses cookies to enhance the user experience.</CookieConsent> }
    </StylesProvider>
    )
}

export default App
